"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(self.webpackChunkgttsgk = self.webpackChunkgttsgk || []).push([[461], {
  935: function _() {
    var te = globalThis;
    function ee(e) {
      return (te.__Zone_symbol_prefix || "__zone_symbol__") + e;
    }
    var ke = Object.getOwnPropertyDescriptor,
      Ne = Object.defineProperty,
      Le = Object.getPrototypeOf,
      _t = Object.create,
      Et = Array.prototype.slice,
      Ie = "addEventListener",
      Me = "removeEventListener",
      Ze = ee(Ie),
      Ae = ee(Me),
      ae = "true",
      le = "false",
      ve = ee("");
    function je(e, r) {
      return Zone.current.wrap(e, r);
    }
    function He(e, r, c, t, i) {
      return Zone.current.scheduleMacroTask(e, r, c, t, i);
    }
    var j = ee,
      we = (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u",
      Te = we ? window : void 0,
      $ = we && Te || globalThis;
    function xe(e, r) {
      for (var c = e.length - 1; c >= 0; c--) "function" == typeof e[c] && (e[c] = je(e[c], r + "_" + c));
      return e;
    }
    function We(e) {
      return !e || !1 !== e.writable && !("function" == typeof e.get && _typeof(e.set) > "u");
    }
    var qe = (typeof WorkerGlobalScope === "undefined" ? "undefined" : _typeof(WorkerGlobalScope)) < "u" && self instanceof WorkerGlobalScope,
      Re = !("nw" in $) && _typeof($.process) < "u" && "[object process]" === $.process.toString(),
      Ve = !Re && !qe && !(!we || !Te.HTMLElement),
      Xe = _typeof($.process) < "u" && "[object process]" === $.process.toString() && !qe && !(!we || !Te.HTMLElement),
      Ce = {},
      yt = j("enable_beforeunload"),
      Ye = function Ye(e) {
        if (!(e = e || $.event)) return;
        var r = Ce[e.type];
        r || (r = Ce[e.type] = j("ON_PROPERTY" + e.type));
        var c = this || e.target || $,
          t = c[r];
        var i;
        return Ve && c === Te && "error" === e.type ? (i = t && t.call(this, e.message, e.filename, e.lineno, e.colno, e.error), !0 === i && e.preventDefault()) : (i = t && t.apply(this, arguments), "beforeunload" === e.type && $[yt] && "string" == typeof i ? e.returnValue = i : null != i && !i && e.preventDefault()), i;
      };
    function $e(e, r, c) {
      var t = ke(e, r);
      if (!t && c && ke(c, r) && (t = {
        enumerable: !0,
        configurable: !0
      }), !t || !t.configurable) return;
      var i = j("on" + r + "patched");
      if (e.hasOwnProperty(i) && e[i]) return;
      delete t.writable, delete t.value;
      var u = t.get,
        E = t.set,
        T = r.slice(2);
      var m = Ce[T];
      m || (m = Ce[T] = j("ON_PROPERTY" + T)), t.set = function (D) {
        var d = this;
        !d && e === $ && (d = $), d && ("function" == typeof d[m] && d.removeEventListener(T, Ye), E && E.call(d, null), d[m] = D, "function" == typeof D && d.addEventListener(T, Ye, !1));
      }, t.get = function () {
        var D = this;
        if (!D && e === $ && (D = $), !D) return null;
        var d = D[m];
        if (d) return d;
        if (u) {
          var w = u.call(this);
          if (w) return t.set.call(this, w), "function" == typeof D.removeAttribute && D.removeAttribute(r), w;
        }
        return null;
      }, Ne(e, r, t), e[i] = !0;
    }
    function Je(e, r, c) {
      if (r) for (var t = 0; t < r.length; t++) $e(e, "on" + r[t], c);else {
        var _t2 = [];
        for (var i in e) "on" == i.slice(0, 2) && _t2.push(i);
        for (var _i = 0; _i < _t2.length; _i++) $e(e, _t2[_i], c);
      }
    }
    var re = j("originalInstance");
    function be(e) {
      var r = $[e];
      if (!r) return;
      $[j(e)] = r, $[e] = function () {
        var i = xe(arguments, e);
        switch (i.length) {
          case 0:
            this[re] = new r();
            break;
          case 1:
            this[re] = new r(i[0]);
            break;
          case 2:
            this[re] = new r(i[0], i[1]);
            break;
          case 3:
            this[re] = new r(i[0], i[1], i[2]);
            break;
          case 4:
            this[re] = new r(i[0], i[1], i[2], i[3]);
            break;
          default:
            throw new Error("Arg list too long.");
        }
      }, fe($[e], r);
      var c = new r(function () {});
      var t;
      for (t in c) "XMLHttpRequest" === e && "responseBlob" === t || function (i) {
        "function" == typeof c[i] ? $[e].prototype[i] = function () {
          return this[re][i].apply(this[re], arguments);
        } : Ne($[e].prototype, i, {
          set: function set(u) {
            "function" == typeof u ? (this[re][i] = je(u, e + "." + i), fe(this[re][i], u)) : this[re][i] = u;
          },
          get: function get() {
            return this[re][i];
          }
        });
      }(t);
      for (t in r) "prototype" !== t && r.hasOwnProperty(t) && ($[e][t] = r[t]);
    }
    function ue(e, r, c) {
      var t = e;
      for (; t && !t.hasOwnProperty(r);) t = Le(t);
      !t && e[r] && (t = e);
      var i = j(r);
      var u = null;
      if (t && (!(u = t[i]) || !t.hasOwnProperty(i)) && (u = t[i] = t[r], We(t && ke(t, r)))) {
        var T = c(u, i, r);
        t[r] = function () {
          return T(this, arguments);
        }, fe(t[r], u);
      }
      return u;
    }
    function mt(e, r, c) {
      var t = null;
      function i(u) {
        var E = u.data;
        return E.args[E.cbIdx] = function () {
          u.invoke.apply(this, arguments);
        }, t.apply(E.target, E.args), u;
      }
      t = ue(e, r, function (u) {
        return function (E, T) {
          var m = c(E, T);
          return m.cbIdx >= 0 && "function" == typeof T[m.cbIdx] ? He(m.name, T[m.cbIdx], m, i) : u.apply(E, T);
        };
      });
    }
    function fe(e, r) {
      e[j("OriginalDelegate")] = r;
    }
    var Ke = !1,
      Ge = !1;
    function kt() {
      if (Ke) return Ge;
      Ke = !0;
      try {
        var e = Te.navigator.userAgent;
        (-1 !== e.indexOf("MSIE ") || -1 !== e.indexOf("Trident/") || -1 !== e.indexOf("Edge/")) && (Ge = !0);
      } catch (_unused) {}
      return Ge;
    }
    function Qe(e) {
      return "function" == typeof e;
    }
    function et(e) {
      return "number" == typeof e;
    }
    var ge = !1;
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) < "u") try {
      var e = Object.defineProperty({}, "passive", {
        get: function get() {
          ge = !0;
        }
      });
      window.addEventListener("test", e, e), window.removeEventListener("test", e, e);
    } catch (_unused2) {
      ge = !1;
    }
    var vt = {
        useG: !0
      },
      ne = {},
      tt = {},
      nt = new RegExp("^" + ve + "(\\w+)(true|false)$"),
      rt = j("propagationStopped");
    function ot(e, r) {
      var c = (r ? r(e) : e) + le,
        t = (r ? r(e) : e) + ae,
        i = ve + c,
        u = ve + t;
      ne[e] = {}, ne[e][le] = i, ne[e][ae] = u;
    }
    function bt(e, r, c, t) {
      var i = t && t.add || Ie,
        u = t && t.rm || Me,
        E = t && t.listeners || "eventListeners",
        T = t && t.rmAll || "removeAllListeners",
        m = j(i),
        D = "." + i + ":",
        d = "prependListener",
        w = "." + d + ":",
        Z = function Z(k, h, H) {
          if (k.isRemoved) return;
          var V = k.callback;
          var Y;
          "object" == _typeof(V) && V.handleEvent && (k.callback = function (g) {
            return V.handleEvent(g);
          }, k.originalDelegate = V);
          try {
            k.invoke(k, h, [H]);
          } catch (g) {
            Y = g;
          }
          var G = k.options;
          return G && "object" == _typeof(G) && G.once && h[u].call(h, H.type, k.originalDelegate ? k.originalDelegate : k.callback, G), Y;
        };
      function x(k, h, H) {
        if (!(h = h || e.event)) return;
        var V = k || h.target || e,
          Y = V[ne[h.type][H ? ae : le]];
        if (Y) {
          var G = [];
          if (1 === Y.length) {
            var g = Z(Y[0], V, h);
            g && G.push(g);
          } else {
            var _g = Y.slice();
            for (var z = 0; z < _g.length && (!h || !0 !== h[rt]); z++) {
              var O = Z(_g[z], V, h);
              O && G.push(O);
            }
          }
          if (1 === G.length) throw G[0];
          var _loop = function _loop() {
            var z = G[_g2];
            r.nativeScheduleMicroTask(function () {
              throw z;
            });
          };
          for (var _g2 = 0; _g2 < G.length; _g2++) {
            _loop();
          }
        }
      }
      var U = function U(k) {
          return x(this, k, !1);
        },
        J = function J(k) {
          return x(this, k, !0);
        };
      function K(k, h) {
        if (!k) return !1;
        var H = !0;
        h && void 0 !== h.useG && (H = h.useG);
        var V = h && h.vh;
        var Y = !0;
        h && void 0 !== h.chkDup && (Y = h.chkDup);
        var G = !1;
        h && void 0 !== h.rt && (G = h.rt);
        var g = k;
        for (; g && !g.hasOwnProperty(i);) g = Le(g);
        if (!g && k[i] && (g = k), !g || g[m]) return !1;
        var z = h && h.eventNameToString,
          O = {},
          R = g[m] = g[i],
          b = g[j(u)] = g[u],
          S = g[j(E)] = g[E],
          Q = g[j(T)] = g[T];
        var W;
        h && h.prepend && (W = g[j(h.prepend)] = g[h.prepend]);
        var q = H ? function (s) {
            if (!O.isExisting) return R.call(O.target, O.eventName, O.capture ? J : U, O.options);
          } : function (s) {
            return R.call(O.target, O.eventName, s.invoke, O.options);
          },
          A = H ? function (s) {
            if (!s.isRemoved) {
              var l = ne[s.eventName];
              var v;
              l && (v = l[s.capture ? ae : le]);
              var C = v && s.target[v];
              if (C) for (var y = 0; y < C.length; y++) if (C[y] === s) {
                C.splice(y, 1), s.isRemoved = !0, s.removeAbortListener && (s.removeAbortListener(), s.removeAbortListener = null), 0 === C.length && (s.allRemoved = !0, s.target[v] = null);
                break;
              }
            }
            if (s.allRemoved) return b.call(s.target, s.eventName, s.capture ? J : U, s.options);
          } : function (s) {
            return b.call(s.target, s.eventName, s.invoke, s.options);
          },
          he = h && h.diff ? h.diff : function (s, l) {
            var v = _typeof(l);
            return "function" === v && s.callback === l || "object" === v && s.originalDelegate === l;
          },
          de = Zone[j("UNPATCHED_EVENTS")],
          oe = e[j("PASSIVE_EVENTS")],
          a = function a(s, l, v, C) {
            var y = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
            var L = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
            return function () {
              var I = this || e;
              var M = arguments[0];
              h && h.transferEventName && (M = h.transferEventName(M));
              var F = arguments[1];
              if (!F) return s.apply(this, arguments);
              if (Re && "uncaughtException" === M) return s.apply(this, arguments);
              var B = !1;
              if ("function" != typeof F) {
                if (!F.handleEvent) return s.apply(this, arguments);
                B = !0;
              }
              if (V && !V(s, F, I, arguments)) return;
              var Ee = ge && !!oe && -1 !== oe.indexOf(M),
                ie = function f(s) {
                  if ("object" == _typeof(s) && null !== s) {
                    var _l = _objectSpread({}, s);
                    return s.signal && (_l.signal = s.signal), _l;
                  }
                  return s;
                }(function N(s, l) {
                  return !ge && "object" == _typeof(s) && s ? !!s.capture : ge && l ? "boolean" == typeof s ? {
                    capture: s,
                    passive: !0
                  } : s ? "object" == _typeof(s) && !1 !== s.passive ? _objectSpread(_objectSpread({}, s), {}, {
                    passive: !0
                  }) : s : {
                    passive: !0
                  } : s;
                }(arguments[2], Ee)),
                me = ie === null || ie === void 0 ? void 0 : ie.signal;
              if (me !== null && me !== void 0 && me.aborted) return;
              if (de) for (var ce = 0; ce < de.length; ce++) if (M === de[ce]) return Ee ? s.call(I, M, F, ie) : s.apply(this, arguments);
              var Be = !!ie && ("boolean" == typeof ie || ie.capture),
                lt = !(!ie || "object" != _typeof(ie)) && ie.once,
                At = Zone.current;
              var Ue = ne[M];
              Ue || (ot(M, z), Ue = ne[M]);
              var ut = Ue[Be ? ae : le];
              var Se,
                pe = I[ut],
                ft = !1;
              if (pe) {
                if (ft = !0, Y) for (var _ce = 0; _ce < pe.length; _ce++) if (he(pe[_ce], F)) return;
              } else pe = I[ut] = [];
              var ht = I.constructor.name,
                dt = tt[ht];
              dt && (Se = dt[M]), Se || (Se = ht + l + (z ? z(M) : M)), O.options = ie, lt && (O.options.once = !1), O.target = I, O.capture = Be, O.eventName = M, O.isExisting = ft;
              var Pe = H ? vt : void 0;
              Pe && (Pe.taskData = O), me && (O.options.signal = void 0);
              var se = At.scheduleEventTask(Se, F, Pe, v, C);
              if (me) {
                O.options.signal = me;
                var _ce2 = function _ce2() {
                  return se.zone.cancelTask(se);
                };
                s.call(me, "abort", _ce2, {
                  once: !0
                }), se.removeAbortListener = function () {
                  return me.removeEventListener("abort", _ce2);
                };
              }
              return O.target = null, Pe && (Pe.taskData = null), lt && (O.options.once = !0), !ge && "boolean" == typeof se.options || (se.options = ie), se.target = I, se.capture = Be, se.eventName = M, B && (se.originalDelegate = F), L ? pe.unshift(se) : pe.push(se), y ? I : void 0;
            };
          };
        return g[i] = a(R, D, q, A, G), W && (g[d] = a(W, w, function (s) {
          return W.call(O.target, O.eventName, s.invoke, O.options);
        }, A, G, !0)), g[u] = function () {
          var s = this || e;
          var l = arguments[0];
          h && h.transferEventName && (l = h.transferEventName(l));
          var v = arguments[2],
            C = !!v && ("boolean" == typeof v || v.capture),
            y = arguments[1];
          if (!y) return b.apply(this, arguments);
          if (V && !V(b, y, s, arguments)) return;
          var L = ne[l];
          var I;
          L && (I = L[C ? ae : le]);
          var M = I && s[I];
          if (M) for (var F = 0; F < M.length; F++) {
            var B = M[F];
            if (he(B, y)) return M.splice(F, 1), B.isRemoved = !0, 0 !== M.length || (B.allRemoved = !0, s[I] = null, C || "string" != typeof l) || (s[ve + "ON_PROPERTY" + l] = null), B.zone.cancelTask(B), G ? s : void 0;
          }
          return b.apply(this, arguments);
        }, g[E] = function () {
          var s = this || e;
          var l = arguments[0];
          h && h.transferEventName && (l = h.transferEventName(l));
          var v = [],
            C = st(s, z ? z(l) : l);
          for (var y = 0; y < C.length; y++) {
            var L = C[y];
            v.push(L.originalDelegate ? L.originalDelegate : L.callback);
          }
          return v;
        }, g[T] = function () {
          var s = this || e;
          var l = arguments[0];
          if (l) {
            h && h.transferEventName && (l = h.transferEventName(l));
            var v = ne[l];
            if (v) {
              var L = s[v[le]],
                I = s[v[ae]];
              if (L) {
                var M = L.slice();
                for (var F = 0; F < M.length; F++) {
                  var B = M[F];
                  this[u].call(this, l, B.originalDelegate ? B.originalDelegate : B.callback, B.options);
                }
              }
              if (I) {
                var _M = I.slice();
                for (var _F = 0; _F < _M.length; _F++) {
                  var _B = _M[_F];
                  this[u].call(this, l, _B.originalDelegate ? _B.originalDelegate : _B.callback, _B.options);
                }
              }
            }
          } else {
            var _v = Object.keys(s);
            for (var C = 0; C < _v.length; C++) {
              var _L = nt.exec(_v[C]);
              var _I = _L && _L[1];
              _I && "removeListener" !== _I && this[T].call(this, _I);
            }
            this[T].call(this, "removeListener");
          }
          if (G) return this;
        }, fe(g[i], R), fe(g[u], b), Q && fe(g[T], Q), S && fe(g[E], S), !0;
      }
      var X = [];
      for (var k = 0; k < c.length; k++) X[k] = K(c[k], t);
      return X;
    }
    function st(e, r) {
      if (!r) {
        var u = [];
        for (var E in e) {
          var T = nt.exec(E);
          var m = T && T[1];
          if (m && (!r || m === r)) {
            var D = e[E];
            if (D) for (var d = 0; d < D.length; d++) u.push(D[d]);
          }
        }
        return u;
      }
      var c = ne[r];
      c || (ot(r), c = ne[r]);
      var t = e[c[le]],
        i = e[c[ae]];
      return t ? i ? t.concat(i) : t.slice() : i ? i.slice() : [];
    }
    function Pt(e, r) {
      var c = e.Event;
      c && c.prototype && r.patchMethod(c.prototype, "stopImmediatePropagation", function (t) {
        return function (i, u) {
          i[rt] = !0, t && t.apply(i, u);
        };
      });
    }
    var De = j("zoneTask");
    function ye(e, r, c, t) {
      var i = null,
        u = null;
      c += t;
      var E = {};
      function T(D) {
        var d = D.data;
        d.args[0] = function () {
          return D.invoke.apply(this, arguments);
        };
        var w = i.apply(e, d.args);
        return et(w) ? d.handleId = w : (d.handle = w, d.isRefreshable = Qe(w.refresh)), D;
      }
      function m(D) {
        var _D$data = D.data,
          d = _D$data.handle,
          w = _D$data.handleId;
        return u.call(e, d !== null && d !== void 0 ? d : w);
      }
      i = ue(e, r += t, function (D) {
        return function (d, w) {
          if (Qe(w[0])) {
            var _ref;
            var Z = {
                isRefreshable: !1,
                isPeriodic: "Interval" === t,
                delay: "Timeout" === t || "Interval" === t ? w[1] || 0 : void 0,
                args: w
              },
              x = w[0];
            w[0] = function () {
              try {
                return x.apply(this, arguments);
              } finally {
                var H = Z.handle,
                  V = Z.handleId,
                  Y = Z.isPeriodic,
                  G = Z.isRefreshable;
                !Y && !G && (V ? delete E[V] : H && (H[De] = null));
              }
            };
            var U = He(r, w[0], Z, T, m);
            if (!U) return U;
            var _U$data = U.data,
              J = _U$data.handleId,
              K = _U$data.handle,
              X = _U$data.isRefreshable,
              k = _U$data.isPeriodic;
            if (J) E[J] = U;else if (K && (K[De] = U, X && !k)) {
              var h = K.refresh;
              K.refresh = function () {
                var H = U.zone,
                  V = U.state;
                return "notScheduled" === V ? (U._state = "scheduled", H._updateTaskCount(U, 1)) : "running" === V && (U._state = "scheduling"), h.call(this);
              };
            }
            return (_ref = K !== null && K !== void 0 ? K : J) !== null && _ref !== void 0 ? _ref : U;
          }
          return D.apply(e, w);
        };
      }), u = ue(e, c, function (D) {
        return function (d, w) {
          var _x;
          var Z = w[0];
          var x;
          et(Z) ? (x = E[Z], delete E[Z]) : (x = Z === null || Z === void 0 ? void 0 : Z[De], x ? Z[De] = null : x = Z), (_x = x) !== null && _x !== void 0 && _x.type ? x.cancelFn && x.zone.cancelTask(x) : D.apply(e, w);
        };
      });
    }
    function it(e, r, c) {
      if (!c || 0 === c.length) return r;
      var t = c.filter(function (u) {
        return u.target === e;
      });
      if (!t || 0 === t.length) return r;
      var i = t[0].ignoreProperties;
      return r.filter(function (u) {
        return -1 === i.indexOf(u);
      });
    }
    function ct(e, r, c, t) {
      e && Je(e, it(e, r, c), t);
    }
    function Fe(e) {
      return Object.getOwnPropertyNames(e).filter(function (r) {
        return r.startsWith("on") && r.length > 2;
      }).map(function (r) {
        return r.substring(2);
      });
    }
    function It(e, r, c, t, i) {
      var u = Zone.__symbol__(t);
      if (r[u]) return;
      var E = r[u] = r[t];
      r[t] = function (T, m, D) {
        return m && m.prototype && i.forEach(function (d) {
          var w = "".concat(c, ".").concat(t, "::") + d,
            Z = m.prototype;
          try {
            if (Z.hasOwnProperty(d)) {
              var x = e.ObjectGetOwnPropertyDescriptor(Z, d);
              x && x.value ? (x.value = e.wrapWithCurrentZone(x.value, w), e._redefineProperty(m.prototype, d, x)) : Z[d] && (Z[d] = e.wrapWithCurrentZone(Z[d], w));
            } else Z[d] && (Z[d] = e.wrapWithCurrentZone(Z[d], w));
          } catch (_unused3) {}
        }), E.call(r, T, m, D);
      }, e.attachOriginToPatched(r[t], E);
    }
    var at = function Oe(_e$Zone) {
      var e = globalThis,
        r = !0 === e[ee("forceDuplicateZoneCheck")];
      if (e.Zone && (r || "function" != typeof e.Zone.__symbol__)) throw new Error("Zone already loaded.");
      return (_e$Zone = e.Zone) !== null && _e$Zone !== void 0 ? _e$Zone : e.Zone = function ze() {
        var e = te.performance;
        function r(N) {
          e && e.mark && e.mark(N);
        }
        function c(N, _) {
          e && e.measure && e.measure(N, _);
        }
        r("Zone");
        var t = function (_N) {
          var N = /*#__PURE__*/function () {
            function N(n, o) {
              _classCallCheck(this, N);
              this._parent = n, this._name = o ? o.name || "unnamed" : "<root>", this._properties = o && o.properties || {}, this._zoneDelegate = new u(this, this._parent && this._parent._zoneDelegate, o);
            }
            return _createClass(N, [{
              key: "parent",
              get: function get() {
                return this._parent;
              }
            }, {
              key: "name",
              get: function get() {
                return this._name;
              }
            }, {
              key: "get",
              value: function get(n) {
                var o = this.getZoneWith(n);
                if (o) return o._properties[n];
              }
            }, {
              key: "getZoneWith",
              value: function getZoneWith(n) {
                var o = this;
                for (; o;) {
                  if (o._properties.hasOwnProperty(n)) return o;
                  o = o._parent;
                }
                return null;
              }
            }, {
              key: "fork",
              value: function fork(n) {
                if (!n) throw new Error("ZoneSpec required!");
                return this._zoneDelegate.fork(this, n);
              }
            }, {
              key: "wrap",
              value: function wrap(n, o) {
                if ("function" != typeof n) throw new Error("Expecting function got: " + n);
                var p = this._zoneDelegate.intercept(this, n, o),
                  P = this;
                return function () {
                  return P.runGuarded(p, this, arguments, o);
                };
              }
            }, {
              key: "run",
              value: function run(n, o, p, P) {
                b = {
                  parent: b,
                  zone: this
                };
                try {
                  return this._zoneDelegate.invoke(this, n, o, p, P);
                } finally {
                  b = b.parent;
                }
              }
            }, {
              key: "runGuarded",
              value: function runGuarded(n) {
                var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                var p = arguments.length > 2 ? arguments[2] : undefined;
                var P = arguments.length > 3 ? arguments[3] : undefined;
                b = {
                  parent: b,
                  zone: this
                };
                try {
                  try {
                    return this._zoneDelegate.invoke(this, n, o, p, P);
                  } catch (q) {
                    if (this._zoneDelegate.handleError(this, q)) throw q;
                  }
                } finally {
                  b = b.parent;
                }
              }
            }, {
              key: "runTask",
              value: function runTask(n, o, p) {
                if (n.zone != this) throw new Error("A task can only be run in the zone of creation! (Creation: " + (n.zone || K).name + "; Execution: " + this.name + ")");
                var P = n,
                  q = n.type,
                  _n$data = n.data,
                  _n$data2 = _n$data === void 0 ? {} : _n$data,
                  _n$data2$isPeriodic = _n$data2.isPeriodic,
                  A = _n$data2$isPeriodic === void 0 ? !1 : _n$data2$isPeriodic,
                  _n$data2$isRefreshabl = _n$data2.isRefreshable,
                  _e = _n$data2$isRefreshabl === void 0 ? !1 : _n$data2$isRefreshabl;
                if (n.state === X && (q === z || q === g)) return;
                var he = n.state != H;
                he && P._transitionTo(H, h);
                var de = S;
                S = P, b = {
                  parent: b,
                  zone: this
                };
                try {
                  q == g && n.data && !A && !_e && (n.cancelFn = void 0);
                  try {
                    return this._zoneDelegate.invokeTask(this, P, o, p);
                  } catch (oe) {
                    if (this._zoneDelegate.handleError(this, oe)) throw oe;
                  }
                } finally {
                  var oe = n.state;
                  if (oe !== X && oe !== Y) if (q == z || A || _e && oe === k) he && P._transitionTo(h, H, k);else {
                    var f = P._zoneDelegates;
                    this._updateTaskCount(P, -1), he && P._transitionTo(X, H, X), _e && (P._zoneDelegates = f);
                  }
                  b = b.parent, S = de;
                }
              }
            }, {
              key: "scheduleTask",
              value: function scheduleTask(n) {
                if (n.zone && n.zone !== this) {
                  var p = this;
                  for (; p;) {
                    if (p === n.zone) throw Error("can not reschedule task to ".concat(this.name, " which is descendants of the original zone ").concat(n.zone.name));
                    p = p.parent;
                  }
                }
                n._transitionTo(k, X);
                var o = [];
                n._zoneDelegates = o, n._zone = this;
                try {
                  n = this._zoneDelegate.scheduleTask(this, n);
                } catch (p) {
                  throw n._transitionTo(Y, k, X), this._zoneDelegate.handleError(this, p), p;
                }
                return n._zoneDelegates === o && this._updateTaskCount(n, 1), n.state == k && n._transitionTo(h, k), n;
              }
            }, {
              key: "scheduleMicroTask",
              value: function scheduleMicroTask(n, o, p, P) {
                return this.scheduleTask(new E(G, n, o, p, P, void 0));
              }
            }, {
              key: "scheduleMacroTask",
              value: function scheduleMacroTask(n, o, p, P, q) {
                return this.scheduleTask(new E(g, n, o, p, P, q));
              }
            }, {
              key: "scheduleEventTask",
              value: function scheduleEventTask(n, o, p, P, q) {
                return this.scheduleTask(new E(z, n, o, p, P, q));
              }
            }, {
              key: "cancelTask",
              value: function cancelTask(n) {
                if (n.zone != this) throw new Error("A task can only be cancelled in the zone of creation! (Creation: " + (n.zone || K).name + "; Execution: " + this.name + ")");
                if (n.state === h || n.state === H) {
                  n._transitionTo(V, h, H);
                  try {
                    this._zoneDelegate.cancelTask(this, n);
                  } catch (o) {
                    throw n._transitionTo(Y, V), this._zoneDelegate.handleError(this, o), o;
                  }
                  return this._updateTaskCount(n, -1), n._transitionTo(X, V), n.runCount = -1, n;
                }
              }
            }, {
              key: "_updateTaskCount",
              value: function _updateTaskCount(n, o) {
                var p = n._zoneDelegates;
                -1 == o && (n._zoneDelegates = null);
                for (var P = 0; P < p.length; P++) p[P]._updateTaskCount(n.type, o);
              }
            }], [{
              key: "assertZonePatched",
              value: function assertZonePatched() {
                if (te.Promise !== O.ZoneAwarePromise) throw new Error("Zone.js has detected that ZoneAwarePromise `(window|global).Promise` has been overwritten.\nMost likely cause is that a Promise polyfill has been loaded after Zone.js (Polyfilling Promise api is not necessary when zone.js is loaded. If you must load one, do so before loading zone.js.)");
              }
            }, {
              key: "root",
              get: function get() {
                var n = N.current;
                for (; n.parent;) n = n.parent;
                return n;
              }
            }, {
              key: "current",
              get: function get() {
                return b.zone;
              }
            }, {
              key: "currentTask",
              get: function get() {
                return S;
              }
            }, {
              key: "__load_patch",
              value: function __load_patch(n, o) {
                var p = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                if (O.hasOwnProperty(n)) {
                  var P = !0 === te[ee("forceDuplicateZoneCheck")];
                  if (!p && P) throw Error("Already loaded patch: " + n);
                } else if (!te["__Zone_disable_" + n]) {
                  var _P = "Zone:" + n;
                  r(_P), O[n] = o(te, N, R), c(_P, _P);
                }
              }
            }]);
          }();
          _N = N;
          _N.__symbol__ = ee;
          return N;
        }();
        var i = {
          name: "",
          onHasTask: function onHasTask(N, _, n, o) {
            return N.hasTask(n, o);
          },
          onScheduleTask: function onScheduleTask(N, _, n, o) {
            return N.scheduleTask(n, o);
          },
          onInvokeTask: function onInvokeTask(N, _, n, o, p, P) {
            return N.invokeTask(n, o, p, P);
          },
          onCancelTask: function onCancelTask(N, _, n, o) {
            return N.cancelTask(n, o);
          }
        };
        var u = /*#__PURE__*/function () {
          function u(_, n, o) {
            _classCallCheck(this, u);
            this._taskCounts = {
              microTask: 0,
              macroTask: 0,
              eventTask: 0
            }, this._zone = _, this._parentDelegate = n, this._forkZS = o && (o && o.onFork ? o : n._forkZS), this._forkDlgt = o && (o.onFork ? n : n._forkDlgt), this._forkCurrZone = o && (o.onFork ? this._zone : n._forkCurrZone), this._interceptZS = o && (o.onIntercept ? o : n._interceptZS), this._interceptDlgt = o && (o.onIntercept ? n : n._interceptDlgt), this._interceptCurrZone = o && (o.onIntercept ? this._zone : n._interceptCurrZone), this._invokeZS = o && (o.onInvoke ? o : n._invokeZS), this._invokeDlgt = o && (o.onInvoke ? n : n._invokeDlgt), this._invokeCurrZone = o && (o.onInvoke ? this._zone : n._invokeCurrZone), this._handleErrorZS = o && (o.onHandleError ? o : n._handleErrorZS), this._handleErrorDlgt = o && (o.onHandleError ? n : n._handleErrorDlgt), this._handleErrorCurrZone = o && (o.onHandleError ? this._zone : n._handleErrorCurrZone), this._scheduleTaskZS = o && (o.onScheduleTask ? o : n._scheduleTaskZS), this._scheduleTaskDlgt = o && (o.onScheduleTask ? n : n._scheduleTaskDlgt), this._scheduleTaskCurrZone = o && (o.onScheduleTask ? this._zone : n._scheduleTaskCurrZone), this._invokeTaskZS = o && (o.onInvokeTask ? o : n._invokeTaskZS), this._invokeTaskDlgt = o && (o.onInvokeTask ? n : n._invokeTaskDlgt), this._invokeTaskCurrZone = o && (o.onInvokeTask ? this._zone : n._invokeTaskCurrZone), this._cancelTaskZS = o && (o.onCancelTask ? o : n._cancelTaskZS), this._cancelTaskDlgt = o && (o.onCancelTask ? n : n._cancelTaskDlgt), this._cancelTaskCurrZone = o && (o.onCancelTask ? this._zone : n._cancelTaskCurrZone), this._hasTaskZS = null, this._hasTaskDlgt = null, this._hasTaskDlgtOwner = null, this._hasTaskCurrZone = null;
            var p = o && o.onHasTask;
            (p || n && n._hasTaskZS) && (this._hasTaskZS = p ? o : i, this._hasTaskDlgt = n, this._hasTaskDlgtOwner = this, this._hasTaskCurrZone = this._zone, o.onScheduleTask || (this._scheduleTaskZS = i, this._scheduleTaskDlgt = n, this._scheduleTaskCurrZone = this._zone), o.onInvokeTask || (this._invokeTaskZS = i, this._invokeTaskDlgt = n, this._invokeTaskCurrZone = this._zone), o.onCancelTask || (this._cancelTaskZS = i, this._cancelTaskDlgt = n, this._cancelTaskCurrZone = this._zone));
          }
          return _createClass(u, [{
            key: "zone",
            get: function get() {
              return this._zone;
            }
          }, {
            key: "fork",
            value: function fork(_, n) {
              return this._forkZS ? this._forkZS.onFork(this._forkDlgt, this.zone, _, n) : new t(_, n);
            }
          }, {
            key: "intercept",
            value: function intercept(_, n, o) {
              return this._interceptZS ? this._interceptZS.onIntercept(this._interceptDlgt, this._interceptCurrZone, _, n, o) : n;
            }
          }, {
            key: "invoke",
            value: function invoke(_, n, o, p, P) {
              return this._invokeZS ? this._invokeZS.onInvoke(this._invokeDlgt, this._invokeCurrZone, _, n, o, p, P) : n.apply(o, p);
            }
          }, {
            key: "handleError",
            value: function handleError(_, n) {
              return !this._handleErrorZS || this._handleErrorZS.onHandleError(this._handleErrorDlgt, this._handleErrorCurrZone, _, n);
            }
          }, {
            key: "scheduleTask",
            value: function scheduleTask(_, n) {
              var o = n;
              if (this._scheduleTaskZS) this._hasTaskZS && o._zoneDelegates.push(this._hasTaskDlgtOwner), o = this._scheduleTaskZS.onScheduleTask(this._scheduleTaskDlgt, this._scheduleTaskCurrZone, _, n), o || (o = n);else if (n.scheduleFn) n.scheduleFn(n);else {
                if (n.type != G) throw new Error("Task is missing scheduleFn.");
                U(n);
              }
              return o;
            }
          }, {
            key: "invokeTask",
            value: function invokeTask(_, n, o, p) {
              return this._invokeTaskZS ? this._invokeTaskZS.onInvokeTask(this._invokeTaskDlgt, this._invokeTaskCurrZone, _, n, o, p) : n.callback.apply(o, p);
            }
          }, {
            key: "cancelTask",
            value: function cancelTask(_, n) {
              var o;
              if (this._cancelTaskZS) o = this._cancelTaskZS.onCancelTask(this._cancelTaskDlgt, this._cancelTaskCurrZone, _, n);else {
                if (!n.cancelFn) throw Error("Task is not cancelable");
                o = n.cancelFn(n);
              }
              return o;
            }
          }, {
            key: "hasTask",
            value: function hasTask(_, n) {
              try {
                this._hasTaskZS && this._hasTaskZS.onHasTask(this._hasTaskDlgt, this._hasTaskCurrZone, _, n);
              } catch (o) {
                this.handleError(_, o);
              }
            }
          }, {
            key: "_updateTaskCount",
            value: function _updateTaskCount(_, n) {
              var o = this._taskCounts,
                p = o[_],
                P = o[_] = p + n;
              if (P < 0) throw new Error("More tasks executed then were scheduled.");
              0 != p && 0 != P || this.hasTask(this._zone, {
                microTask: o.microTask > 0,
                macroTask: o.macroTask > 0,
                eventTask: o.eventTask > 0,
                change: _
              });
            }
          }]);
        }();
        var E = /*#__PURE__*/function () {
          function E(_, n, o, p, P, q) {
            _classCallCheck(this, E);
            if (this._zone = null, this.runCount = 0, this._zoneDelegates = null, this._state = "notScheduled", this.type = _, this.source = n, this.data = p, this.scheduleFn = P, this.cancelFn = q, !o) throw new Error("callback is not defined");
            this.callback = o;
            var A = this;
            this.invoke = _ === z && p && p.useG ? E.invokeTask : function () {
              return E.invokeTask.call(te, A, this, arguments);
            };
          }
          return _createClass(E, [{
            key: "zone",
            get: function get() {
              return this._zone;
            }
          }, {
            key: "state",
            get: function get() {
              return this._state;
            }
          }, {
            key: "cancelScheduleRequest",
            value: function cancelScheduleRequest() {
              this._transitionTo(X, k);
            }
          }, {
            key: "_transitionTo",
            value: function _transitionTo(_, n, o) {
              if (this._state !== n && this._state !== o) throw new Error("".concat(this.type, " '").concat(this.source, "': can not transition to '").concat(_, "', expecting state '").concat(n, "'").concat(o ? " or '" + o + "'" : "", ", was '").concat(this._state, "'."));
              this._state = _, _ == X && (this._zoneDelegates = null);
            }
          }, {
            key: "toString",
            value: function toString() {
              return this.data && _typeof(this.data.handleId) < "u" ? this.data.handleId.toString() : Object.prototype.toString.call(this);
            }
          }, {
            key: "toJSON",
            value: function toJSON() {
              return {
                type: this.type,
                state: this.state,
                source: this.source,
                zone: this.zone.name,
                runCount: this.runCount
              };
            }
          }], [{
            key: "invokeTask",
            value: function invokeTask(_, n, o) {
              _ || (_ = this), Q++;
              try {
                return _.runCount++, _.zone.runTask(_, n, o);
              } finally {
                1 == Q && J(), Q--;
              }
            }
          }]);
        }();
        var T = ee("setTimeout"),
          m = ee("Promise"),
          D = ee("then");
        var Z,
          d = [],
          w = !1;
        function x(N) {
          if (Z || te[m] && (Z = te[m].resolve(0)), Z) {
            var _ = Z[D];
            _ || (_ = Z.then), _.call(Z, N);
          } else te[T](N, 0);
        }
        function U(N) {
          0 === Q && 0 === d.length && x(J), N && d.push(N);
        }
        function J() {
          if (!w) {
            for (w = !0; d.length;) {
              var N = d;
              d = [];
              for (var _ = 0; _ < N.length; _++) {
                var n = N[_];
                try {
                  n.zone.runTask(n, null, null);
                } catch (o) {
                  R.onUnhandledError(o);
                }
              }
            }
            R.microtaskDrainDone(), w = !1;
          }
        }
        var K = {
            name: "NO ZONE"
          },
          X = "notScheduled",
          k = "scheduling",
          h = "scheduled",
          H = "running",
          V = "canceling",
          Y = "unknown",
          G = "microTask",
          g = "macroTask",
          z = "eventTask",
          O = {},
          R = {
            symbol: ee,
            currentZoneFrame: function currentZoneFrame() {
              return b;
            },
            onUnhandledError: W,
            microtaskDrainDone: W,
            scheduleMicroTask: U,
            showUncaughtError: function showUncaughtError() {
              return !t[ee("ignoreConsoleErrorUncaughtError")];
            },
            patchEventTarget: function patchEventTarget() {
              return [];
            },
            patchOnProperties: W,
            patchMethod: function patchMethod() {
              return W;
            },
            bindArguments: function bindArguments() {
              return [];
            },
            patchThen: function patchThen() {
              return W;
            },
            patchMacroTask: function patchMacroTask() {
              return W;
            },
            patchEventPrototype: function patchEventPrototype() {
              return W;
            },
            isIEOrEdge: function isIEOrEdge() {
              return !1;
            },
            getGlobalObjects: function getGlobalObjects() {},
            ObjectDefineProperty: function ObjectDefineProperty() {
              return W;
            },
            ObjectGetOwnPropertyDescriptor: function ObjectGetOwnPropertyDescriptor() {},
            ObjectCreate: function ObjectCreate() {},
            ArraySlice: function ArraySlice() {
              return [];
            },
            patchClass: function patchClass() {
              return W;
            },
            wrapWithCurrentZone: function wrapWithCurrentZone() {
              return W;
            },
            filterProperties: function filterProperties() {
              return [];
            },
            attachOriginToPatched: function attachOriginToPatched() {
              return W;
            },
            _redefineProperty: function _redefineProperty() {
              return W;
            },
            patchCallbacks: function patchCallbacks() {
              return W;
            },
            nativeScheduleMicroTask: x
          };
        var b = {
            parent: null,
            zone: new t(null, null)
          },
          S = null,
          Q = 0;
        function W() {}
        return c("Zone", "Zone"), t;
      }(), e.Zone;
    }();
    (function Zt(e) {
      (function Nt(e) {
        e.__load_patch("ZoneAwarePromise", function (r, c, t) {
          var i = Object.getOwnPropertyDescriptor,
            u = Object.defineProperty,
            T = t.symbol,
            m = [],
            D = !1 !== r[T("DISABLE_WRAPPING_UNCAUGHT_PROMISE_REJECTION")],
            d = T("Promise"),
            w = T("then");
          t.onUnhandledError = function (f) {
            if (t.showUncaughtError()) {
              var a = f && f.rejection;
              a ? console.error("Unhandled Promise rejection:", a instanceof Error ? a.message : a, "; Zone:", f.zone.name, "; Task:", f.task && f.task.source, "; Value:", a, a instanceof Error ? a.stack : void 0) : console.error(f);
            }
          }, t.microtaskDrainDone = function () {
            var _loop2 = function _loop2() {
              var f = m.shift();
              try {
                f.zone.runGuarded(function () {
                  throw f.throwOriginal ? f.rejection : f;
                });
              } catch (a) {
                U(a);
              }
            };
            for (; m.length;) {
              _loop2();
            }
          };
          var x = T("unhandledPromiseRejectionHandler");
          function U(f) {
            t.onUnhandledError(f);
            try {
              var a = c[x];
              "function" == typeof a && a.call(this, f);
            } catch (_unused4) {}
          }
          function J(f) {
            return f && f.then;
          }
          function K(f) {
            return f;
          }
          function X(f) {
            return A.reject(f);
          }
          var k = T("state"),
            h = T("value"),
            H = T("finally"),
            V = T("parentPromiseValue"),
            Y = T("parentPromiseState"),
            g = null,
            z = !0,
            O = !1;
          function b(f, a) {
            return function (s) {
              try {
                N(f, a, s);
              } catch (l) {
                N(f, !1, l);
              }
            };
          }
          var S = function S() {
              var f = !1;
              return function (s) {
                return function () {
                  f || (f = !0, s.apply(null, arguments));
                };
              };
            },
            Q = "Promise resolved with itself",
            W = T("currentTaskTrace");
          function N(f, a, s) {
            var l = S();
            if (f === s) throw new TypeError(Q);
            if (f[k] === g) {
              var v = null;
              try {
                ("object" == _typeof(s) || "function" == typeof s) && (v = s && s.then);
              } catch (C) {
                return l(function () {
                  N(f, !1, C);
                })(), f;
              }
              if (a !== O && s instanceof A && s.hasOwnProperty(k) && s.hasOwnProperty(h) && s[k] !== g) n(s), N(f, s[k], s[h]);else if (a !== O && "function" == typeof v) try {
                v.call(s, l(b(f, a)), l(b(f, !1)));
              } catch (C) {
                l(function () {
                  N(f, !1, C);
                })();
              } else {
                f[k] = a;
                var C = f[h];
                if (f[h] = s, f[H] === H && a === z && (f[k] = f[Y], f[h] = f[V]), a === O && s instanceof Error) {
                  var y = c.currentTask && c.currentTask.data && c.currentTask.data.__creationTrace__;
                  y && u(s, W, {
                    configurable: !0,
                    enumerable: !1,
                    writable: !0,
                    value: y
                  });
                }
                for (var _y = 0; _y < C.length;) o(f, C[_y++], C[_y++], C[_y++], C[_y++]);
                if (0 == C.length && a == O) {
                  f[k] = 0;
                  var _y2 = s;
                  try {
                    throw new Error("Uncaught (in promise): " + function E(f) {
                      return f && f.toString === Object.prototype.toString ? (f.constructor && f.constructor.name || "") + ": " + JSON.stringify(f) : f ? f.toString() : Object.prototype.toString.call(f);
                    }(s) + (s && s.stack ? "\n" + s.stack : ""));
                  } catch (L) {
                    _y2 = L;
                  }
                  D && (_y2.throwOriginal = !0), _y2.rejection = s, _y2.promise = f, _y2.zone = c.current, _y2.task = c.currentTask, m.push(_y2), t.scheduleMicroTask();
                }
              }
            }
            return f;
          }
          var _ = T("rejectionHandledHandler");
          function n(f) {
            if (0 === f[k]) {
              try {
                var a = c[_];
                a && "function" == typeof a && a.call(this, {
                  rejection: f[h],
                  promise: f
                });
              } catch (_unused5) {}
              f[k] = O;
              for (var _a = 0; _a < m.length; _a++) f === m[_a].promise && m.splice(_a, 1);
            }
          }
          function o(f, a, s, l, v) {
            n(f);
            var C = f[k],
              y = C ? "function" == typeof l ? l : K : "function" == typeof v ? v : X;
            a.scheduleMicroTask("Promise.then", function () {
              try {
                var L = f[h],
                  I = !!s && H === s[H];
                I && (s[V] = L, s[Y] = C);
                var M = a.run(y, void 0, I && y !== X && y !== K ? [] : [L]);
                N(s, !0, M);
              } catch (L) {
                N(s, !1, L);
              }
            }, s);
          }
          var P = function P() {},
            q = r.AggregateError;
          var A = /*#__PURE__*/function () {
            function A(a) {
              _classCallCheck(this, A);
              var s = this;
              if (!(s instanceof A)) throw new Error("Must be an instanceof Promise.");
              s[k] = g, s[h] = [];
              try {
                var l = S();
                a && a(l(b(s, z)), l(b(s, O)));
              } catch (l) {
                N(s, !1, l);
              }
            }
            return _createClass(A, [{
              key: Symbol.toStringTag,
              get: function get() {
                return "Promise";
              }
            }, {
              key: Symbol.species,
              get: function get() {
                return A;
              }
            }, {
              key: "then",
              value: function then(a, s) {
                var _this$constructor;
                var l = (_this$constructor = this.constructor) === null || _this$constructor === void 0 ? void 0 : _this$constructor[Symbol.species];
                (!l || "function" != typeof l) && (l = this.constructor || A);
                var v = new l(P),
                  C = c.current;
                return this[k] == g ? this[h].push(C, v, a, s) : o(this, C, v, a, s), v;
              }
            }, {
              key: "catch",
              value: function _catch(a) {
                return this.then(null, a);
              }
            }, {
              key: "finally",
              value: function _finally(a) {
                var _this$constructor2;
                var s = (_this$constructor2 = this.constructor) === null || _this$constructor2 === void 0 ? void 0 : _this$constructor2[Symbol.species];
                (!s || "function" != typeof s) && (s = A);
                var l = new s(P);
                l[H] = H;
                var v = c.current;
                return this[k] == g ? this[h].push(v, l, a, a) : o(this, v, l, a, a), l;
              }
            }], [{
              key: "toString",
              value: function toString() {
                return "function ZoneAwarePromise() { [native code] }";
              }
            }, {
              key: "resolve",
              value: function resolve(a) {
                return a instanceof A ? a : N(new this(null), z, a);
              }
            }, {
              key: "reject",
              value: function reject(a) {
                return N(new this(null), O, a);
              }
            }, {
              key: "withResolvers",
              value: function withResolvers() {
                var a = {};
                return a.promise = new A(function (s, l) {
                  a.resolve = s, a.reject = l;
                }), a;
              }
            }, {
              key: "any",
              value: function any(a) {
                if (!a || "function" != typeof a[Symbol.iterator]) return Promise.reject(new q([], "All promises were rejected"));
                var s = [];
                var l = 0;
                try {
                  var _iterator = _createForOfIteratorHelper(a),
                    _step;
                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      var y = _step.value;
                      l++, s.push(A.resolve(y));
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                } catch (_unused6) {
                  return Promise.reject(new q([], "All promises were rejected"));
                }
                if (0 === l) return Promise.reject(new q([], "All promises were rejected"));
                var v = !1;
                var C = [];
                return new A(function (y, L) {
                  for (var I = 0; I < s.length; I++) s[I].then(function (M) {
                    v || (v = !0, y(M));
                  }, function (M) {
                    C.push(M), l--, 0 === l && (v = !0, L(new q(C, "All promises were rejected")));
                  });
                });
              }
            }, {
              key: "race",
              value: function race(a) {
                var s,
                  l,
                  v = new this(function (L, I) {
                    s = L, l = I;
                  });
                function C(L) {
                  s(L);
                }
                function y(L) {
                  l(L);
                }
                var _iterator2 = _createForOfIteratorHelper(a),
                  _step2;
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var L = _step2.value;
                    J(L) || (L = this.resolve(L)), L.then(C, y);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
                return v;
              }
            }, {
              key: "all",
              value: function all(a) {
                return A.allWithCallback(a);
              }
            }, {
              key: "allSettled",
              value: function allSettled(a) {
                return (this && this.prototype instanceof A ? this : A).allWithCallback(a, {
                  thenCallback: function thenCallback(l) {
                    return {
                      status: "fulfilled",
                      value: l
                    };
                  },
                  errorCallback: function errorCallback(l) {
                    return {
                      status: "rejected",
                      reason: l
                    };
                  }
                });
              }
            }, {
              key: "allWithCallback",
              value: function allWithCallback(a, s) {
                var _this = this;
                var l,
                  v,
                  C = new this(function (M, F) {
                    l = M, v = F;
                  }),
                  y = 2,
                  L = 0;
                var I = [];
                var _iterator3 = _createForOfIteratorHelper(a),
                  _step3;
                try {
                  var _loop3 = function _loop3() {
                    var M = _step3.value;
                    J(M) || (M = _this.resolve(M));
                    var F = L;
                    try {
                      M.then(function (B) {
                        I[F] = s ? s.thenCallback(B) : B, y--, 0 === y && l(I);
                      }, function (B) {
                        s ? (I[F] = s.errorCallback(B), y--, 0 === y && l(I)) : v(B);
                      });
                    } catch (B) {
                      v(B);
                    }
                    y++, L++;
                  };
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    _loop3();
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
                return y -= 2, 0 === y && l(I), C;
              }
            }]);
          }();
          A.resolve = A.resolve, A.reject = A.reject, A.race = A.race, A.all = A.all;
          var _e = r[d] = r.Promise;
          r.Promise = A;
          var he = T("thenPatched");
          function de(f) {
            var a = f.prototype,
              s = i(a, "then");
            if (s && (!1 === s.writable || !s.configurable)) return;
            var l = a.then;
            a[w] = l, f.prototype.then = function (v, C) {
              var _this2 = this;
              return new A(function (L, I) {
                l.call(_this2, L, I);
              }).then(v, C);
            }, f[he] = !0;
          }
          return t.patchThen = de, _e && (de(_e), ue(r, "fetch", function (f) {
            return function oe(f) {
              return function (a, s) {
                var l = f.apply(a, s);
                if (l instanceof A) return l;
                var v = l.constructor;
                return v[he] || de(v), l;
              };
            }(f);
          })), Promise[c.__symbol__("uncaughtPromiseErrors")] = m, A;
        });
      })(e), function Lt(e) {
        e.__load_patch("toString", function (r) {
          var c = Function.prototype.toString,
            t = j("OriginalDelegate"),
            i = j("Promise"),
            u = j("Error"),
            E = function E() {
              if ("function" == typeof this) {
                var d = this[t];
                if (d) return "function" == typeof d ? c.call(d) : Object.prototype.toString.call(d);
                if (this === Promise) {
                  var w = r[i];
                  if (w) return c.call(w);
                }
                if (this === Error) {
                  var _w = r[u];
                  if (_w) return c.call(_w);
                }
              }
              return c.call(this);
            };
          E[t] = c, Function.prototype.toString = E;
          var T = Object.prototype.toString;
          Object.prototype.toString = function () {
            return "function" == typeof Promise && this instanceof Promise ? "[object Promise]" : T.call(this);
          };
        });
      }(e), function Mt(e) {
        e.__load_patch("util", function (r, c, t) {
          var i = Fe(r);
          t.patchOnProperties = Je, t.patchMethod = ue, t.bindArguments = xe, t.patchMacroTask = mt;
          var u = c.__symbol__("BLACK_LISTED_EVENTS"),
            E = c.__symbol__("UNPATCHED_EVENTS");
          r[E] && (r[u] = r[E]), r[u] && (c[u] = c[E] = r[u]), t.patchEventPrototype = Pt, t.patchEventTarget = bt, t.isIEOrEdge = kt, t.ObjectDefineProperty = Ne, t.ObjectGetOwnPropertyDescriptor = ke, t.ObjectCreate = _t, t.ArraySlice = Et, t.patchClass = be, t.wrapWithCurrentZone = je, t.filterProperties = it, t.attachOriginToPatched = fe, t._redefineProperty = Object.defineProperty, t.patchCallbacks = It, t.getGlobalObjects = function () {
            return {
              globalSources: tt,
              zoneSymbolEventNames: ne,
              eventNames: i,
              isBrowser: Ve,
              isMix: Xe,
              isNode: Re,
              TRUE_STR: ae,
              FALSE_STR: le,
              ZONE_SYMBOL_PREFIX: ve,
              ADD_EVENT_LISTENER_STR: Ie,
              REMOVE_EVENT_LISTENER_STR: Me
            };
          };
        });
      }(e);
    })(at), function Ot(e) {
      e.__load_patch("legacy", function (r) {
        var c = r[e.__symbol__("legacyPatch")];
        c && c();
      }), e.__load_patch("timers", function (r) {
        var c = "set",
          t = "clear";
        ye(r, c, t, "Timeout"), ye(r, c, t, "Interval"), ye(r, c, t, "Immediate");
      }), e.__load_patch("requestAnimationFrame", function (r) {
        ye(r, "request", "cancel", "AnimationFrame"), ye(r, "mozRequest", "mozCancel", "AnimationFrame"), ye(r, "webkitRequest", "webkitCancel", "AnimationFrame");
      }), e.__load_patch("blocking", function (r, c) {
        var t = ["alert", "prompt", "confirm"];
        for (var i = 0; i < t.length; i++) ue(r, t[i], function (E, T, m) {
          return function (D, d) {
            return c.current.run(E, r, d, m);
          };
        });
      }), e.__load_patch("EventTarget", function (r, c, t) {
        (function Dt(e, r) {
          r.patchEventPrototype(e, r);
        })(r, t), function Ct(e, r) {
          if (Zone[r.symbol("patchEventTarget")]) return;
          var _r$getGlobalObjects = r.getGlobalObjects(),
            c = _r$getGlobalObjects.eventNames,
            t = _r$getGlobalObjects.zoneSymbolEventNames,
            i = _r$getGlobalObjects.TRUE_STR,
            u = _r$getGlobalObjects.FALSE_STR,
            E = _r$getGlobalObjects.ZONE_SYMBOL_PREFIX;
          for (var m = 0; m < c.length; m++) {
            var D = c[m],
              Z = E + (D + u),
              x = E + (D + i);
            t[D] = {}, t[D][u] = Z, t[D][i] = x;
          }
          var T = e.EventTarget;
          T && T.prototype && r.patchEventTarget(e, r, [T && T.prototype]);
        }(r, t);
        var i = r.XMLHttpRequestEventTarget;
        i && i.prototype && t.patchEventTarget(r, t, [i.prototype]);
      }), e.__load_patch("MutationObserver", function (r, c, t) {
        be("MutationObserver"), be("WebKitMutationObserver");
      }), e.__load_patch("IntersectionObserver", function (r, c, t) {
        be("IntersectionObserver");
      }), e.__load_patch("FileReader", function (r, c, t) {
        be("FileReader");
      }), e.__load_patch("on_property", function (r, c, t) {
        !function St(e, r) {
          if (Re && !Xe || Zone[e.symbol("patchEvents")]) return;
          var c = r.__Zone_ignore_on_properties;
          var t = [];
          if (Ve) {
            var i = window;
            t = t.concat(["Document", "SVGElement", "Element", "HTMLElement", "HTMLBodyElement", "HTMLMediaElement", "HTMLFrameSetElement", "HTMLFrameElement", "HTMLIFrameElement", "HTMLMarqueeElement", "Worker"]);
            var u = function pt() {
              try {
                var _e2 = Te.navigator.userAgent;
                if (-1 !== _e2.indexOf("MSIE ") || -1 !== _e2.indexOf("Trident/")) return !0;
              } catch (_unused7) {}
              return !1;
            }() ? [{
              target: i,
              ignoreProperties: ["error"]
            }] : [];
            ct(i, Fe(i), c && c.concat(u), Le(i));
          }
          t = t.concat(["XMLHttpRequest", "XMLHttpRequestEventTarget", "IDBIndex", "IDBRequest", "IDBOpenDBRequest", "IDBDatabase", "IDBTransaction", "IDBCursor", "WebSocket"]);
          for (var _i2 = 0; _i2 < t.length; _i2++) {
            var _u = r[t[_i2]];
            _u && _u.prototype && ct(_u.prototype, Fe(_u.prototype), c);
          }
        }(t, r);
      }), e.__load_patch("customElements", function (r, c, t) {
        !function Rt(e, r) {
          var _r$getGlobalObjects2 = r.getGlobalObjects(),
            c = _r$getGlobalObjects2.isBrowser,
            t = _r$getGlobalObjects2.isMix;
          (c || t) && e.customElements && "customElements" in e && r.patchCallbacks(r, e.customElements, "customElements", "define", ["connectedCallback", "disconnectedCallback", "adoptedCallback", "attributeChangedCallback", "formAssociatedCallback", "formDisabledCallback", "formResetCallback", "formStateRestoreCallback"]);
        }(r, t);
      }), e.__load_patch("XHR", function (r, c) {
        !function D(d) {
          var w = d.XMLHttpRequest;
          if (!w) return;
          var Z = w.prototype;
          var U = Z[Ze],
            J = Z[Ae];
          if (!U) {
            var R = d.XMLHttpRequestEventTarget;
            if (R) {
              var b = R.prototype;
              U = b[Ze], J = b[Ae];
            }
          }
          var K = "readystatechange",
            X = "scheduled";
          function k(R) {
            var b = R.data,
              S = b.target;
            S[E] = !1, S[m] = !1;
            var Q = S[u];
            U || (U = S[Ze], J = S[Ae]), Q && J.call(S, K, Q);
            var W = S[u] = function () {
              if (S.readyState === S.DONE) if (!b.aborted && S[E] && R.state === X) {
                var _ = S[c.__symbol__("loadfalse")];
                if (0 !== S.status && _ && _.length > 0) {
                  var n = R.invoke;
                  R.invoke = function () {
                    var o = S[c.__symbol__("loadfalse")];
                    for (var p = 0; p < o.length; p++) o[p] === R && o.splice(p, 1);
                    !b.aborted && R.state === X && n.call(R);
                  }, _.push(R);
                } else R.invoke();
              } else !b.aborted && !1 === S[E] && (S[m] = !0);
            };
            return U.call(S, K, W), S[t] || (S[t] = R), z.apply(S, b.args), S[E] = !0, R;
          }
          function h() {}
          function H(R) {
            var b = R.data;
            return b.aborted = !0, O.apply(b.target, b.args);
          }
          var V = ue(Z, "open", function () {
              return function (R, b) {
                return R[i] = 0 == b[2], R[T] = b[1], V.apply(R, b);
              };
            }),
            G = j("fetchTaskAborting"),
            g = j("fetchTaskScheduling"),
            z = ue(Z, "send", function () {
              return function (R, b) {
                if (!0 === c.current[g] || R[i]) return z.apply(R, b);
                {
                  var S = {
                      target: R,
                      url: R[T],
                      isPeriodic: !1,
                      args: b,
                      aborted: !1
                    },
                    Q = He("XMLHttpRequest.send", h, S, k, H);
                  R && !0 === R[m] && !S.aborted && Q.state === X && Q.invoke();
                }
              };
            }),
            O = ue(Z, "abort", function () {
              return function (R, b) {
                var S = function x(R) {
                  return R[t];
                }(R);
                if (S && "string" == typeof S.type) {
                  if (null == S.cancelFn || S.data && S.data.aborted) return;
                  S.zone.cancelTask(S);
                } else if (!0 === c.current[G]) return O.apply(R, b);
              };
            });
        }(r);
        var t = j("xhrTask"),
          i = j("xhrSync"),
          u = j("xhrListener"),
          E = j("xhrScheduled"),
          T = j("xhrURL"),
          m = j("xhrErrorBeforeScheduled");
      }), e.__load_patch("geolocation", function (r) {
        r.navigator && r.navigator.geolocation && function gt(e, r) {
          var c = e.constructor.name;
          var _loop4 = function _loop4() {
            var i = r[t],
              u = e[i];
            if (u) {
              if (!We(ke(e, i))) return 1; // continue
              e[i] = function (T) {
                var m = function m() {
                  return T.apply(this, xe(arguments, c + "." + i));
                };
                return fe(m, T), m;
              }(u);
            }
          };
          for (var t = 0; t < r.length; t++) {
            if (_loop4()) continue;
          }
        }(r.navigator.geolocation, ["getCurrentPosition", "watchPosition"]);
      }), e.__load_patch("PromiseRejectionEvent", function (r, c) {
        function t(i) {
          return function (u) {
            st(r, i).forEach(function (T) {
              var m = r.PromiseRejectionEvent;
              if (m) {
                var D = new m(i, {
                  promise: u.promise,
                  reason: u.rejection
                });
                T.invoke(D);
              }
            });
          };
        }
        r.PromiseRejectionEvent && (c[j("unhandledPromiseRejectionHandler")] = t("unhandledrejection"), c[j("rejectionHandledHandler")] = t("rejectionhandled"));
      }), e.__load_patch("queueMicrotask", function (r, c, t) {
        !function wt(e, r) {
          r.patchMethod(e, "queueMicrotask", function (c) {
            return function (t, i) {
              Zone.current.scheduleMicroTask("queueMicrotask", i[0]);
            };
          });
        }(r, t);
      });
    }(at);
  }
}, function (te) {
  te(te.s = 935);
}]);